export const dm_news_insights = () => {
    if (!$('#posts-container').length) return;

    const params = new URLSearchParams(window.location.search);
    let currentPage = params.get('page', 1) || 1;
    params.forEach((v, k) => {
        if (k.startsWith('service_')) {
            $(`[name="service[]"][data-slug="${v}"]`).prop('checked', true);
        }
        if (k.startsWith('category_')) {
            $(`[name="category[]"][data-slug="${v}"]`).prop('checked', true);
        }
    });

    if (params.get('search')) {
        $('[name="search"]').val(decodeURIComponent(params.get('search')));
    }

    const sort = params.get('sort', 'date_desc') || 'date_desc';
    $(`[name="sort"][value="${sort}"]`).prop('checked', true);

    const postsContainer = $('#posts-container');
    const paginationContainer = $('#pagination-container');
    $(document).on('click', '#pagination-container a', function (e) {
        e.preventDefault();
        const link = $(this).attr('href');
        if (link.includes('page/')) {
            let page = link.split('page/')[1];
            page = page.replace('/', '');
            currentPage = parseInt(page);
        } else {
            currentPage = 1;
        }

        fetchResults();
    });

    const postsFilterForm = $('#posts-filter-form');
    postsFilterForm.submit((e) => {
        e.preventDefault();
        currentPage = 1;
        fetchResults();
        $('.filter-item').removeClass('open');
    });

    const fetchResults = async () => {
        let sort = $('[name="sort"]:checked').val();
        const [sortTitle, sortDir] = sort.split('_');

        const service = Array.from($('[name="service[]"]:checked')).map(i => $(i).data('slug'));
        const category = Array.from($('[name="category[]"]:checked')).map(i => $(i).data('slug'));
        const searchKeyword = $('[name="search"]').val();

        let urlParams = [];
        let i = 1;
        for (const s of service) {
            urlParams.push(`service_${i}=${s}`);
            i++;
        }
        i = 1;
        for (const c of category) {
            urlParams.push(`category_${i}=${c}`);
            i++;
        }
        if (searchKeyword) {
            urlParams.push(`search=${encodeURIComponent(searchKeyword)}`);
        }
        urlParams.push(`sort=${sort}`);
        urlParams.push(`page=${currentPage}`);
        urlParams = urlParams.join('&');
        history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);

        $('#page').append(`
            <div id="page-loader">
            <div class="spinner"></div>
            </div>
        `);
        document.getElementById('posts-filter-form').scrollIntoView();
        const res = await $.ajax({
            url: '/wp-json/news/search',
            type: 'POST',
            data: {
                service: service,
                category: category,
                search: searchKeyword || null,
                order_by: {'date': 'post_date', 'title': 'post_title'}[sortTitle],
                order_dir: sortDir,
                page: currentPage,
            },
            dataType: 'json'
        });
        $('#page #page-loader').remove();

        postsContainer.html(res.results_html);
        paginationContainer.html(res.links_html);
    }

    fetchResults();
}

const setValuesFromUrlParams = () => {

}
